import Footer from "../components/footer";
import Header from "../components/header";
import HeroSection from "../components/hero_section";
import MainBody from "../components/main";
import Layout from "../components/layout";
import { SocialProvider } from "../hooks/useSocial";

export default function HomePage() {
  return (
    <SocialProvider>
      <Layout>
        <Header />
        <HeroSection />
        <MainBody />
        <Footer />
      </Layout>
    </SocialProvider>
  );
}
